module.exports = __webpack_public_path__ + "img/p4.66122ef8.png";